export default __webpack_public_path__ + "642d03e2d35706017ef3b061618e55d7.svg";